import { PauseCircle, PlayCircle } from "lucide-react-native";
import React from "react";
import { Pressable } from "react-native";

interface AudioToggleButtonProps {
  className?: string;
  isPlaying: boolean;
  isLoading: boolean;
  onPress: () => void;
  disabled?: boolean;
  size?: number;
  color?: string;
}

const AudioToggleButton: React.FC<AudioToggleButtonProps> = ({
  className,
  isPlaying,
  isLoading,
  onPress,
  disabled = false,
  size = 24,
  color = "black",
}) => (
  <Pressable
    className={`${className} cursor-pointer ${disabled ? "opacity-50" : ""}`}
    onPress={onPress}
    disabled={disabled || isLoading}
  >
    {disabled ? (
      <PlayCircle size={size} color="#6b7280" />
    ) : isPlaying ? (
      <PauseCircle size={size} color={color} />
    ) : (
      <PlayCircle size={size} color={color} />
    )}
  </Pressable>
);

export default AudioToggleButton;
